import { useEffect, useState } from "react";
import { detectVisitorCountry, readCachedCountry } from "../utils/detectCountry";

export function useVisitorCountry() {
  const [country, setCountry] = useState(() => readCachedCountry());
  const [ready, setReady] = useState(() => Boolean(readCachedCountry()));

  useEffect(() => {
    let cancelled = false;
    detectVisitorCountry().then((code) => {
      if (!cancelled) {
        setCountry(code);
        setReady(true);
      }
    });
    return () => {
      cancelled = true;
    };
  }, []);

  return { country, ready };
}
